<!-- <p>reports-page-data works!</p> -->
<section>
  <div
    class=""
    [ngClass]="{
      'reports-page-data-header':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
      'reports-page-data-header-mobile': screenSize == ScreenType.Mobile
    }"
  >
    Enter Search Parameters
  </div>
  <mat-divider></mat-divider>
  <form [formGroup]="reportData">
    <div class="reports-page-data-container">
      <mat-grid-list
        [cols]="screenSize == ScreenType.Mobile ? 1 : 4"
        rowHeight="100px"
        [gutterSize]="'18px'"
      >
        <mat-grid-tile rowspan="4" *ngIf = 'isFace'>
          <div class="upload-reports-face">
            <div class="upload-reports-face-image-container">
              <img [src]="eventEvidence" alt="" />
            </div>
            <div class="upload-face-button">
              <label 
                for="evidencepic"
                class="upload-button-label"
                [class.disabled]="!isFace"
                [matTooltip]="true ? 'Subscribe to avail this feature' : 'Upload Face'"
                >Upload Face</label
              >
              <input
                [disabled]="!isFace && isDisableFeature"
                style="display: none"
                (change)="onUploadFace($event)"
                id="evidencepic"
                type="file"
                accept="image/*"
                [matTooltip]="true ? 'Subscribe to avail this feature' : 'Upload Face'"
              />
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-form-field
            hideRequiredMarker
            subscriptSizing="dynamic"
            appearance="outline"
          >
            <mat-label>Select Module</mat-label>
            <input
              matInput
              (input)="filterSource($event)"
              placeholder="Search Source"
              [matAutocomplete]="auto"
              formControlName="module"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onChooseModule($event)"
            >
            <!-- [disabled]="!eventEvidence" -->
              <mat-option
                value="All"
                matTooltip="Select all incident types"
                >All (For Face only)
                </mat-option
              >
              <mat-option
                *ngFor="let incidentType of filteredIncidentTypes"
                [value]="incidentType"
              >
                {{ incidentType }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            ><mat-label>From Date</mat-label>
            <input
              matInput
              [readonly]="true"
              [max]="maxDate"
              [matDatepicker]="startDatePicker"
              formControlName="startDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            ><mat-label>To Date</mat-label>
            <input
              matInput
              [readonly]="true"
              [max]="maxDate"
              [matDatepicker]="endDatePicker"
              formControlName="endDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="isIncident || isANPR">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Source</mat-label>
            <input
              matInput
              (input)="filterAssets($event)"
              placeholder="Search Assets"
              [matAutocomplete]="auto"
              formControlName="source"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onSelectAsset($event)"
            >
              <mat-option
                *ngFor="let asset of filteredAssets"
                [value]="asset.assetName"
              >
                {{ asset.assetName | titlecase }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="isANPR">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>ANPR Search</mat-label>
            <input
              matInput
              placeholder="ANPR Search"
              formControlName="vehicleNumber"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="isVisitor">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Visitor Search</mat-label>
            <input
              matInput
              placeholder="Search by Id, Name or Phone Number"
              formControlName="visitorSearch"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="isReportGenerated || eventEvidence" colspan="2">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Select Recievers</mat-label>
            <div class="list">
              <mat-chip-row
                *ngFor="let user of selectedUsers"
                [removable]="true"
                (removed)="removeReceiver(user)"
              >
                {{ user.firstname + " " + user.lastname | titlecase }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              <input
                matInput
                [matAutocomplete]="auto"
                (input)="filterUsers($event)"
                [formControl]="recipientsControl"
                placeholder="Search Recievers"
              />
            </div>

            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onSelectReceiver($event)"
            >
              <mat-option *ngFor="let user of filteredUsers" [value]="user">
                {{ user.firstname + " " + user.lastname | titlecase }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="isReportGenerated && !eventEvidence">
          <div
            [ngClass]="{
              'button-inside-mat-grid':
                screenSize == ScreenType.Desktop ||
                screenSize == ScreenType.Tablet,
              'button-inside-mat-grid-mobile': screenSize == ScreenType.Mobile
            }"
          >
            <button
              [disabled]="selectedUsers.length == 0"
              (click)="sendEmails()"
              mat-raised-button
            >
              Send Email
            </button>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div
            [ngClass]="{
              'button-inside-mat-grid':
                screenSize == ScreenType.Desktop ||
                screenSize == ScreenType.Tablet,
              'button-inside-mat-grid-mobile': screenSize == ScreenType.Mobile
            }"
          >
            <button
              [disabled]="
                reportData.invalid ||
                (selectedUsers.length == 0 && eventEvidence != null)
              "
              (click)="submitRequest()"
              mat-raised-button
            >
              Submit Request
            </button>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </form>
</section>
<mat-divider></mat-divider>
<section *ngIf="isReportGenerated" class="collect-reports-section">
  <section style="height: auto; width: 100%" *ngIf="!isEmployee" >
    <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="100px">
      <mat-grid-tile [ngClass]="{'control-button':screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet}">
        <button
          style="margin-right: 10px;"
          (click)="exportToPdf()"
          mat-fab
          extended
        >
          Export to PDF
        </button>
        <button (click)="exportToCsv()" mat-fab extended>Export to CSV</button>
      </mat-grid-tile>
      <mat-grid-tile [ngClass]="{'control-search':screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet}">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width: 50%"
          ><mat-label>Search</mat-label>
          <input matInput [(ngModel)]="searchText" (input)="onSearch()" />
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
    <ag-grid-angular
      class="ag-theme-alpine"
      style="height: 400px; width: 100%"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [getRowHeight]="getRowHeight"
      [rowData]="tableData"
      [gridOptions]="{
        defaultColDef: { resizable: true, sortable: true, filter: true }
      }"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="onDataRendered($event)"
    />
    <div class="total-records">Total Records: {{ totalRecords }}</div>
  </section>
  <section *ngIf="isEmployee">
    <div class="employee-table-report-wrapper">
      <app-employee-attendance-report
        [employees]="dataSource"
      ></app-employee-attendance-report>
    </div>
  </section>
</section>
<ng-template #SubmittingRequestDialog>
  <h2 matDialogTitle>Please wait!</h2>
  <mat-dialog-content>
    <i>Your Request has been Submited!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>
